import React from "react";
import "./maintenance.css";

const MaintenancePage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white text-center px-4 sm:px-6">
      <div className="container w-full max-w-md p-6 sm:p-8 bg-white rounded-lg shadow-lg">
       
          <div className="animation flex justify-center">
            <div className="one spin-one"></div>
            <div className="two spin-two"></div>
            <div className="three spin-one"></div>
          </div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800 mt-4">🚧 Under Maintenance 🚧</h1>
          <p className="text-sm sm:text-base text-gray-600 mt-2">
            Update in progress. Please run the installer to finish the update.
          </p>
          <p className="text-xs sm:text-sm text-gray-600 mt-2">
            Maintenance screen for{" "}
            <a
              href="https://www.ladesk.com/?utm_source=maintenance&utm_campaign=maintenance/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              LiveAgent
            </a>
          </p>
      
      </div>
    </div>
  );
};

export default MaintenancePage;
